import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

import { UiCommandEvent } from '@ui/cer-ui-types';

export class DataJobTaskLogForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({
      mandatory: true,
      viewMetadata: {
        dataApiName: 'DataJobTaskLog',
        name: 'job-opgave-log', text: 'Datajob opgavelog',
        allowCreate: false, allowEdit: false, allowDelete: false,
        primaryKey: 'id', 
        baseFields: ['id'],
        navigations: [
          { link: 'nav', foreignKey: { parentEntity: 'DataJobTaskLogError', parentColumn: 'jobTaskLogId', column: 'id'}},
          { link: 'fk', foreignKey: { parentEntity: 'DataJobLog', parentColumn: 'id', column: 'jobLogId'}}
        ]
      },
      fieldMetadata: [
        { name: 'jobLogId', text: 'Job', foreignKeyTableName: 'DataJobLog', foreignKeyField: 'id', foreignKeyValue: 'sourceAddress'  },
        { name: 'fileName', text: 'Opgave' },
        { name: 'isPickedUp', text: 'Hentet?', format: 'CheckBox', width: '45px' },
        { name: 'isProcessed', text: 'Behandlet?', format: 'CheckBox', width: '45px'  },
        { name: 'isCompleted', text: 'Indlæst?', format: 'CheckBox', width: '45px'  },
        { name: 'isFailed', text: 'Fejlet?', format: 'CheckBox', width: '45px'  },
        { name: 'isIgnored', text: 'Ignoreret?', format: 'CheckBox', width: '45px'  },
        { name: 'isCopied', text: 'Kopieret?', format: 'CheckBox', width: '45px'  },
        { name: 'durationSeconds', text: 'Tid (sek)', format: 'Number0', width: '45px'  },
        { name: 'created', text: 'Oprettet', format: 'DateTime', orderBy: 'Descending', width: '120px' },
        { name: 'modified', text: 'Ændret', format: 'DateTime', visible: false, width: '120px' }
      ],
      contextMenuCommands: [],
      //onCommandEvent: (e => this.onCommand(e)),
    });
  }

  // Commands
  public onCommand(event: UiCommandEvent) {
  }
}
